import React, { useEffect, useRef, useState } from "react";
import { Button } from "../../globalStyles";
import { FiUsers, FiUserCheck } from "react-icons/fi";
import { AiFillStar } from "react-icons/ai";

const SelectProfessional = ({
  label,
  staffs,
  selectedId,
  onChange,
  selectedNailservices,
  selectedBeautyservices,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedServiceIds = [
    ...(Array.isArray(selectedNailservices) ? selectedNailservices : []),
    ...(Array.isArray(selectedBeautyservices) ? selectedBeautyservices : []),
  ];

  const filteredStaffs = staffs.filter((staff) => {
    const allServices = [
      ...(staff.nailService || []),
      ...(staff.beautyService || []),
    ];
    return selectedServiceIds.every((id) => allServices.includes(id));
  });

  const selectedStaff =
    selectedId && typeof selectedId === "object"
      ? staffs.find((s) => s._id === selectedId._id)
      : null;

  const option = [
    // {
    //   _id: "any",
    //   name: "Any professional for maximum availability",
    //   role: "",
    //   icon: (
    //     <FiUsers
    //       className={`text-2xl ${
    //         selectedStaff ? "text-yellowlight" : "text-yellowdark"
    //       } mb-1`}
    //     />
    //   ),
    // },
    // {
    //   _id: "per-service",
    //   name: "Select professional per selected service",
    //   role: "",
    //   icon: (
    //     <FiUserCheck
    //       className={`text-2xl ${
    //         selectedStaff ? "text-yellowlight" : "text-yellowdark"
    //       } mb-1`}
    //     />
    //   ),
    // },
  ];

  const professionalsTotal = [...option, ...staffs];

  const professionalsperService = [...option, ...filteredStaffs];

  const selectedStaffId =
    typeof selectedId === "object" ? selectedId._id : selectedId;

  console.log({ selectedStaff });

  // const displayedProfessionals =
  //   selectedStaffId === "per-service"
  //     ? professionalsperService
  //     : professionalsTotal;

  const displayedProfessionals = professionalsperService;

  const scrollRef = useRef(null);

  useEffect(() => {
    if (isOpen && scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [isOpen]);

  return (
    <div className="relative inline-block text-left ">
      <h2 className="text-xl font-bold text-yellowlight mb-3">{label}</h2>

      <button
        onClick={() => setIsOpen(true)}
        className={`w-full p-3 rounded-lg border text-left min-h-[2.5rem] ${
          selectedStaff
            ? "border-yellowlight text-white"
            : "border-border text-gray-400"
        }`}
      >
        {!selectedStaff ? (
          <p className="text-textGray text-sm italic">
            Click box to select staff
          </p>
        ) : (
          <div className="font-medium text-text text-2xl flex items-center">
            <img
              src={selectedStaff.photo}
              alt={selectedStaff.name}
              className="w-10 h-10 rounded-full object-cover mr-2"
            />
            <span>{selectedStaff.name}</span>
            {/* <span className="ml-2">
              <AiFillStar className="ml-2 text-yellow-400 text-2xl" />
            </span> */}
          </div>
        )}
      </button>

      {isOpen && (
        <div className="fixed inset-0 bg-black/40 z-[9999] flex items-center justify-center overflow-y-auto">
          <div
            className="bg-dry border border-yellowlight w-[95vw] max-w-2xl rounded-xl p-4 mt-10 mb-10 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl font-bold text-yellowlight mb-3">
              Choose a professional
            </h2>
            <div
              ref={scrollRef}
              className="border-t border-b border-border rounded p-5 overflow-y-auto max-h-[60vh]"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                {displayedProfessionals.length === 0 ? (
                  <div className="col-span-full text-center text-gray-400 text-sm">
                    No staff available.
                  </div>
                ) : (
                  displayedProfessionals.map((pro) => (
                    <button
                      key={pro._id}
                      onClick={() =>
                        onChange({
                          _id: pro._id,
                          name: pro.name,
                          photo: pro.photo,
                        })
                      }
                      className={`flex flex-col items-center text-xl p-2 border border-border rounded-lg cursor-pointer ${
                        selectedStaffId === pro._id
                          ? "bg-yellowlight text-yellowdark"
                          : "bg-none text-text"
                      }`}
                    >
                      {pro.photo ? (
                        <div className="relative mb-3">
                          <img
                            src={pro.photo}
                            alt={pro.name}
                            className="w-20 h-20 rounded-lg object-cover"
                          />
                        </div>
                      ) : (
                        <div className="text-3xl mb-2 mt-2">
                          {React.cloneElement(pro.icon, {
                            className: `text-2xl ${
                              selectedStaffId === pro._id
                                ? "text-yellowdark"
                                : "text-yellowlight"
                            }`,
                          })}
                        </div>
                      )}
                      <div className="font-medium mb-2 mt-0">{pro.name}</div>
                    </button>
                  ))
                )}
              </div>
            </div>

            {/* Button area */}
            <div className="flex justify-end gap-3 mt-4">
              <Button
                className="text-sm px-4 py-2 bg-none text-yellowlight hover:text-white rounded-md"
                onClick={() => onChange([])}
              >
                Clear
              </Button>
              <Button
                className="text-sm px-4 py-2 bg-yellowlight text-yellowdark rounded-md"
                onClick={() => setIsOpen(false)}
              >
                Done
              </Button>
            </div>

            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-black"
              onClick={() => setIsOpen(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectProfessional;
